import { HeadingText } from '@/components/atoms/HeadingText';
import { Textarea } from '@/components/atoms/Textarea';
import { useFormContext } from '@/components/forms/FormContext';
import {
	type ReplaceVirtuallyFormState,
	StepMap,
	steps,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import { isValid } from './state';
import { Step } from '@/components/forms/Step';
import { handleNext } from './routing';
import { useValidateStep } from '@/components/forms/useValidateStep';
import { ReplaceVirtuallyFormActionMap } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/reducer';
import { TextAlert } from '@/components/calculators/TextAlert';
import { IconInfoBubble } from '@/components/icons';

export interface MessageStepProps {
	testId?: string;
}

const MessageStep = (props: MessageStepProps) => {
	const { testId = 'MessageStep' } = props;
	const { state, dispatch } = useFormContext<
		StepMap,
		ReplaceVirtuallyFormState,
		ReplaceVirtuallyFormActionMap
	>();
	useValidateStep<
		StepMap,
		ReplaceVirtuallyFormState,
		ReplaceVirtuallyFormActionMap
	>(isValid, steps.Message);

	function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
		dispatch({ type: 'UPDATE_MESSAGE', payload: event.target.value });
	}

	return (
		<div data-testid={testId}>
			<Step<StepMap, ReplaceVirtuallyFormState, ReplaceVirtuallyFormActionMap>
				name={steps.Message}
				onNext={handleNext}
			>
				<HeadingText
					tag="h1"
					size="h2"
					className="mb-10 mt-10 lg:mb-14 lg:mt-20"
					balanced
				>
					Anything else you’d like to add?
				</HeadingText>

				<div className="mb-8 grid gap-6 lg:mb-10 lg:grid-cols-3 lg:gap-8">
					<div className="lg:col-start-2">
						<Textarea
							id="message"
							name="message"
							label="Comments"
							inputClassName="!h-full"
							fieldsetClassName="h-full"
							onChange={handleChange}
							value={state.message}
						/>
					</div>
				</div>
				<TextAlert
					id="WhatAsking"
					renderIcon={IconInfoBubble}
					title="What are we looking for here?"
					text="Add anything you think would help us customize your solution. If nothing comes to mind, feel free to skip to the next step! "
				/>
			</Step>
		</div>
	);
};

export default MessageStep;
